import {
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';
import { AppFormikTextField } from 'shared/components/AppComponents';

interface CertificationFormProps {
  test: any;
}

export const certificationRefField = [
  'recurrence_months',
  'certification_valid_months',
];

const CertificationForm: React.FC<CertificationFormProps> = () => {
  const certificationRef = useRef<HTMLDivElement | null>(null);
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('md'));
  const { errors, submitCount } = useFormikContext<any>();

  useEffect(() => {
    if (submitCount === 0) return;
    if (!errors || Object.keys(errors).length === 0) return;

    const certificationError = certificationRefField.some(
      (field) => errors?.[field]
    );

    if (certificationError) {
      certificationRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors, submitCount]);

  return (
    <Paper variant="outlined" ref={certificationRef}>
      <Typography variant="h6">Recurrence and certification</Typography>

      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Stack direction="column" width="100%">
          <AppFormikTextField
            name="recurrence_months"
            label="Recurrence (months)"
            placeholder="12"
            outerLabel
          />
          <Typography component="span" sx={{ color: '#7E7E7E' }}>
            How often should this training be repeated?
          </Typography>
        </Stack>
        <Stack direction="column" width="100%">
          <AppFormikTextField
            name="certification_valid_months"
            label="Certification valid (months)"
            placeholder="24"
            outerLabel
          />
          <Typography component="span" sx={{ color: '#7E7E7E' }}>
            How long is the certification valid?
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default CertificationForm;
